import api from './axios';

// Authentication
export const loginAdmin = async (phoneNumber) => {
  const response = await api.post('/api/admin/auth/login', { phoneNumber });
  return response.data;
};

export const verifyAdminOtp = async (phoneNumber, otp) => {
  const response = await api.post('/api/admin/auth/verify-otp', { phoneNumber, otp });
  return response.data;
};

export const resendAdminOtp = async (phoneNumber) => {
  const response = await api.post('/api/admin/auth/resend-otp', { phoneNumber });
  return response.data;
};

// Analytics
export const getAnalytics = async () => {
  const response = await api.get('/api/admin/analytics');
  return response.data;
};

// Users
export const getPendingUsers = async (params = {}) => {
  const response = await api.get('/api/admin/users/pending', { params });
  return response.data;
};

export const getUsers = async (params = {}) => {
  const response = await api.get('/api/admin/users', { params });
  return response.data;
};

export const getUserDetails = async (userId) => {
  const response = await api.get(`/api/admin/users/${userId}`);
  return response.data;
};

export const updateUserStatus = async (userId, status, reason) => {
  const response = await api.patch(`/api/admin/users/${userId}/verify`, { status, reason });
  return response.data;
};

export const addUserNote = async (userId, notes) => {
  const response = await api.post(`/api/admin/users/${userId}/notes`, { notes });
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await api.delete(`/api/admin/users/${userId}`);
  return response.data;
};

// ============================================
// EVENT MANAGEMENT (Admin)
// ============================================

// Get all events with pagination and filters
export const getEvents = async (params = {}) => {
  const response = await api.get('/api/admin/events', { params });
  return response.data;
};

// Get single event by ID
export const getEventDetails = async (eventId) => {
  const response = await api.get(`/api/admin/events/${eventId}`);
  return response.data;
};

// Get event attendees
export const getEventAttendees = async (eventId, params = {}) => {
  const response = await api.get(`/api/admin/events/${eventId}/attendees`, { params });
  return response.data;
};

// Get event waitlist
export const getEventWaitlist = async (eventId) => {
  const response = await api.get(`/api/admin/events/${eventId}/waitlist`);
  return response.data;
};

// Create new event
export const createEvent = async (data) => {
  const response = await api.post('/api/admin/events', data);
  return response.data;
};

// Update event
export const updateEvent = async (eventId, data) => {
  const response = await api.put(`/api/admin/events/${eventId}`, data);
  return response.data;
};

// Update event status
export const updateEventStatus = async (eventId, status) => {
  const response = await api.patch(`/api/admin/events/${eventId}/status`, { status });
  return response.data;
};

// Delete/Cancel event
export const deleteEvent = async (eventId, reason = '') => {
  const response = await api.delete(`/api/admin/events/${eventId}`, { data: { reason } });
  return response.data;
};

// Check in attendee
export const checkInAttendee = async (eventId, userId) => {
  const response = await api.post(`/api/admin/events/${eventId}/check-in/${userId}`);
  return response.data;
};

// Companion management
export const getPendingCompanions = async (params = {}) => {
  const response = await api.get('/api/admin/companions/pending', { params });
  return response.data;
};

export const reviewCompanion = async (profileId, decision) => {
  const response = await api.patch(`/api/admin/companions/${profileId}/review`, { decision });
  return response.data;
};
